export const OMIT = 'OMIT';
export const PIPELINE = 'PIPELINE';
export const BEST_CASE = 'BEST_CASE';
export const COMMIT = 'COMMIT';
export const CLOSED = 'CLOSED';
export const DEFAULT_CATEGORIES_EDITABLE = [PIPELINE, BEST_CASE, COMMIT];
export const DEFAULT_CATEGORIES_NOT_EDITABLE = [OMIT, CLOSED];
export const DEFAULT_CATEGORIES_MAPPABLE = [PIPELINE, BEST_CASE, COMMIT, CLOSED];
export const DEFAULT_CATEGORIES_NOT_MAPPABLE = [OMIT];